import styled from '@emotion/styled';

import { BRAND_COLORS, COLORS } from 'styles/theme';

const PaymentInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem;

  font-weight: bold;
  font-size: 1.35rem;
`;

const PaymentLabel = styled.div`
  color: ${COLORS.mineShaft};
`;

const PaymentPrice = styled.div`
  color: ${BRAND_COLORS.accent};

  &::after {
    content: '원';
    color: ${COLORS.mineShaft};
  }
`;

export { PaymentInfo, PaymentLabel, PaymentPrice };
